import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default {
  path: "/project",
  redirect: "/project",
  name: "Project",
  component: LAYOUT,
  meta: {
    order: 10,
    roles: ManagerType.Root,
    title: "项目管理",
  },
  children: [
    {
      path: "",
      name: "ProjectPage",
      component: () => import("../../views/project/ProjectPage.vue"),
      meta: {
        title: "项目管理",
        icon: "si:projects-fill",
        roles: ManagerType.Root,
      },
    },
  ],
} as RouteRecordRaw;
